/* NuBest search drawer v2.1 — one small behaviour on top of the theme's predictive search.
   After "Clear" empties the field, the cursor goes back into it (the theme's own handler does the clearing and
   re-runs the search state). Nothing else is needed: typing, results, arrow keys and "view all" are the theme's.
   ES5 on purpose (older iOS Safari). */
(function () {
  'use strict';
  if (window.__nbSearchBound) return;
  window.__nbSearchBound = true;
  document.addEventListener('click', function (e) {
    var node = e.target;
    var btn = node && node.closest ? node.closest('[data-clear-search]') : null;
    if (!btn) return;
    var root = btn.closest ? btn.closest('[data-nbs]') : null;
    if (!root) return;
    var input = root.querySelector('[data-input-search]');
    if (input) input.focus();
  });
})();
